import React from 'react';
import { renderIf, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const BaasicTextAreaTemplate = ({ field, t, ...props }) => {
	const { readOnly, removeLabel } = props;
	return (
		<div className="inputgroup">
			{!removeLabel && (
				<label htmlFor={field.id} className="form__label--required">
					{t(field.label)}
					{renderIf(field.$rules && field.$rules.includes('required') && !isSome(field.error) && field.$value)(
						<span className="form__label--check type--color--success">
							<i className="fa fa-check-circle"></i>
						</span>
					)}
				</label>
			)}
			<textarea
				rows="5"
				className={
					field.$rules && field.$rules.includes('required') && !isSome(field.error) && field.$value
						? 'input input--textarea input__wrap--valid'
						: 'input input--textarea'
				}
				readOnly={readOnly}
				{...field.bind()}
			/>
			{renderIf(field.error)(<p className="type--tny type--color--error">{t(field.error)}</p>)}
		</div>
	);
};

export default defaultTemplate(BaasicTextAreaTemplate);
